import React, {Component} from "react";

import {Link} from 'react-router-dom';
import { connect } from "react-redux";
import { updateForm, setPage } from "../../../store/actions/FormAction";
/*
    Importing ExpansionPanel component from Material-UI for Accordian
*/
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

/*
    Importing Notice for dismissable alerts
*/
import Notice from "./partials/Notice";
/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();
/*
    Dashboard view that displays the Dashboard pages
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class Profile extends Component {
  constructor(){
    super();

    this.editInfo = this.editInfo.bind(this);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleEmailKeyUp = this.handleEmailKeyUp.bind(this);
    this.handlePhoneKeyUp = this.handlePhoneKeyUp.bind(this);

    this.togglePreferences = this.togglePreferences.bind(this);
    this.toggleReferences = this.toggleReferences.bind(this);

  }
  componentDidMount() {
    this.props.updateForm("pagename", "Profile");
    this.props.setPage("viewprofile");
    this.editInfo = this.editInfo.bind(this);

    //For Testing Purposes
    if (this.props.st.length < 1){
      this.props.updateForm("fn", "John");
      this.props.updateForm("ln", "Doe");

      this.props.updateForm("address", "123 Main St, Columbus, OH, 34567");
      this.props.updateForm("street", "123 Main St");
      this.props.updateForm("city", "Columbus");
      this.props.updateForm("st", "Ohio");
      this.props.updateForm("stt", "OH");
      this.props.updateForm("zip", "34567");

      this.props.updateForm("eml", "jonathandoe@johndoeacct.com");
      this.props.updateForm("phn", "512-321-4567");

      this.props.updateForm("ismobile", true);
      this.props.updateForm("ssn", "XXX-XX-1234");
      this.props.updateForm("co", "ABCD Co");
      this.props.updateForm("cophn", "412-321-4567");
      this.props.updateForm("payfrequency", "Bi-Weekly");
      this.props.updateForm("payamount", "1643.56");
      this.props.updateForm("accounttype", "Checking");
      this.props.updateForm("bankaccount", "81214654564");
      this.props.updateForm("routingnum", "012100564");
      this.props.updateForm("sig1", "1234");
      this.props.updateForm("sig2", "1234");
      this.props.updateForm("sig3", "1234");

      this.props.updateForm("ref1fn", "Mary");
      this.props.updateForm("ref1ln", "Doe");
      this.props.updateForm("ref1phn", "512-321-4567");
      this.props.updateForm("ref1rel", "Sister");
      this.props.updateForm("ref2fn", "Jenny");
      this.props.updateForm("ref2ln", "Appleseed");
      this.props.updateForm("ref2phn", "312-555-4863");
      this.props.updateForm("ref2rel", "Cousin");
    }
  }

  editInfo(e){
    if (e.target.parentNode.classList.contains('editpen')){
      e.target.parentNode.parentNode.classList.add("hidden");
      e.target.parentNode.parentNode.nextSibling.classList.remove("hidden");
    } else {
      e.target.parentNode.classList.add("hidden");
      e.target.parentNode.nextSibling.classList.remove("hidden");
    }
  }

  handleEmailChange(e) {
    let email = e.target.value;
    this.props.updateForm("eml", email);

    let emltip = document.getElementById("emltip");
    const emaillabel = document.querySelector("label[for='eml']");

    if (validation.validateEmail(email)) {
      this.emailchecked = true;
      emltip.innerHTML = "";
      emltip.classList.add("hidden");
      emaillabel.classList.add("active");
    } else {
      this.emailchecked = false;
      emaillabel.classList.remove("active");
    }
    this.props.updateForm("allchecked", validation.checkAll([true,this.emailchecked,this.passwordchecked,this.econsentchecked]));
  }

  handleEmailKeyUp(e) {
    // eslint-disable-next-line
    if(e.keyCode == 13){
      let emltip = document.getElementById("emltip");
      const emaillabel = document.querySelector("label[for='eml']");

      if (validation.validateEmail(this.props.eml)) {
        this.emailchecked = true;
        emltip.innerHTML = "";
        emltip.classList.add("hidden");
        emaillabel.classList.add("active");
        document.getElementById("emlfield").classList.add("hidden");
        document.getElementById("emlbox").classList.remove("hidden");
      } else {
        this.emailchecked = false;
        emaillabel.classList.remove("active");
      }
      this.props.updateForm("allchecked", validation.checkAll([true,this.emailchecked,this.passwordchecked,this.econsentchecked]));
    }
  }
  handleEmailBlur(e) {
    let email = e.target.value;
    let emltip = document.getElementById("emltip");

    if (!validation.validateEmail(email)) {
      emltip.innerHTML = email + " is not a valid email.";
      emltip.classList.remove("hidden");
    } else {
      document.getElementById("emlfield").classList.add("hidden");
      document.getElementById("emlbox").classList.remove("hidden");
    }
  }

  handlePhoneKeyUp(e) {
    // eslint-disable-next-line
    if(e.keyCode == 13){
      let phntip = document.getElementById("phntip");
      const phnlabel = document.querySelector("label[for='phn']");

      if (validation.validatePhone(this.props.phn)){
        phntip.classList.add("hidden");
        phntip.innerHTML = "";
        phnlabel.classList.add("active");
        document.getElementById("phnfield").classList.add("hidden");
        document.getElementById("phnbox").classList.remove("hidden");
      } else {
        phnlabel.classList.remove("active");
      }
    }
  }
  handlePhoneChange(e) {
    let phn = e.target.value;

    phn = phn.replace(/\D/g, '');
    let split = 3;
    let chunk = [];
    for (let i = 0; i < phn.length; i += split) {
      split = (i <= 3) ? 3 : 4;
      chunk.push( phn.substr( i, split ) );
    }
    if (chunk[0]) chunk[0] = validation.checkPhoneNum(chunk[0], 200);
    let tmp = chunk.join("-");
    this.props.updateForm("phn", tmp);

    let phntip = document.getElementById("phntip");
    const phnlabel = document.querySelector("label[for='phn']");

    if (validation.validatePhone(phn)){
      phntip.classList.add("hidden");
      phntip.innerHTML = "";
      phnlabel.classList.add("active");
    } else {
      phnlabel.classList.remove("active");
    }
  }
  handlePhoneBlur(e) {
    let phn = e.target.value;
    let phntip = document.getElementById("phntip");

    if (!validation.validatePhone(phn)){
      phntip.classList.remove("hidden");
      phntip.innerHTML = "Please enter a valid phone number.";
    } else {
      document.getElementById("phnfield").classList.add("hidden");
      document.getElementById("phnbox").classList.remove("hidden");
    }
  }

  togglePreferences(e){
    let preferences = document.getElementById("preferences");

    let titleareanode = e.target;
    if (e.target.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode;
    } else if (e.target.parentNode.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode.parentNode;
    } else if (e.target.parentNode.parentNode.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode.parentNode.parentNode;
    }

    if (preferences.classList.contains('noheight')){
      preferences.classList.remove("noheight");
      preferences.classList.add("newheight");
      titleareanode.classList.add("pref-open");
    } else {
      preferences.classList.add("noheight");
      preferences.classList.remove("newheight");
      titleareanode.classList.remove("pref-open");
    }
  }

  toggleReferences(e){
    let references = document.getElementById("references");
    let titleareanode = e.target;
    if (e.target.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode;
    } else if (e.target.parentNode.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode.parentNode;
    } else if (e.target.parentNode.parentNode.parentNode.classList.contains('preferences')){
      titleareanode = e.target.parentNode.parentNode.parentNode;
    }
    if (references.classList.contains('noheight')){
      references.classList.remove("noheight");
      references.classList.add("newheight");
      titleareanode.classList.add("pref-open");
    } else {
      references.classList.add("noheight");
      references.classList.remove("newheight");
      titleareanode.classList.remove("pref-open");
    }
  }


  render() {

    return (
      <div id="dashboard2">
        <div className="dashheader">
          {this.props.pagename}
        </div>

        { !this.props.noticedismissed && <Notice /> }

        <div className="dashmain">

          <h6 style={{marginTop:'-5px',marginBottom:'20px',fontWeight:"600"}}>Last Log in: <span style={{fontWeight:"400"}}>&nbsp;Jun 13, 2018 3:25 PM ET</span></h6>
          <h4>Personal Information</h4>

          <div className="detailsbox">
            <h5>Name</h5>
            <div id="nmbox">
              <p>John Doe</p>
              <svg className="editpen hidden" onClick={this.editInfo} width="11px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
              </svg>
            </div>
            <div id="nmfield" className="hidden">
              <input type="text" placeholder="First Name" id="fn" className="form-control" value={this.props.fn} onChange={this.changeInfo} onBlur={this.updateInfo}/>
              <input type="text" placeholder="Last Name" id="ln" className="form-control ptop" value={this.props.ln} onChange={this.changeInfo} onBlur={this.updateInfo}/>
            </div>
          </div>
          <div className="detailsbox">
            <h5>Email</h5>
            <div id="emlbox">
              <p>{this.props.eml}</p>
              <svg className="editpen" onClick={this.editInfo} width="11px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
              </svg>
            </div>
            <div id="emlfield" className="form-group hidden">
              <label htmlFor="eml" >
                  <div className="errortip hidden" id="emltip">
                      Please provide a valid email address.
                  </div>
                  <input type="email" name="eml" id="eml" className="form-control" value={this.props.eml} onChange={this.handleEmailChange} onBlur={this.handleEmailBlur} onKeyUp={this.handleEmailKeyUp}/>
              </label>
            </div>
          </div>
          <div className="detailsbox">
            <h5>Phone</h5>
            <div id="phnbox">
              <p>{this.props.phn}</p>
              <svg className="editpen" onClick={this.editInfo} width="11px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
              </svg>
            </div>
            <div id="phnfield" className="form-group hidden">
              <label htmlFor="phn">
                <div className="errortip hidden" id="phntip">
                    Please provide a valid phone number.
                </div>
                <input type="tel" name="phn" id="phn" className="form-control" placeholder="eg: 512-123-4567" value={this.props.phn} onChange={this.handlePhoneChange} onBlur={this.handlePhoneBlur} onKeyUp={this.handlePhoneKeyUp} maxLength="12"/>
              </label>
            </div>
          </div>
          <div className="detailsbox">
            <h5>Street Address</h5>
            <div>
              <p>{this.props.street}</p>
            </div>
          </div>
          <div className="detailsbox">
            <h5>City</h5>
            <div>
              <p>{this.props.city}</p>
            </div>
          </div>
          <div className="detailsbox">
            <h5>State</h5>
            <div>
              <p>{this.props.st}</p>
            </div>
          </div>
          <div className="detailsbox">
            <h5>Zip</h5>
            <div>
              <p>{this.props.zip}</p>
            </div>
          </div>

          <hr />

          <h4>Account Servicing</h4>

          <div className="changedrop">
            <h4 className="preferences" onClick={this.togglePreferences}>
              <svg className="actioncaret" width="20px" viewBox="0 0 20 20">
                <g strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-39.000000, -368.000000) translate(49.000000, 378.000000) scale(1, -1) translate(-49.000000, -378.000000) translate(40.000000, 369.000000)" stroke="#6E7677">
                  <circle className="Oval-3" strokeWidth="0.5" cx="9" cy="9" r="9"></circle>
                  <polyline className="downarrow" strokeWidth="1.0546875" strokeLinecap="round" points="6.19272374 10.2351675 8.90261101 7.47070736 11.6124983 10.2351675"></polyline>
                </g>
              </svg>
              <span>Communication preferences</span>
            </h4>
            <div id="preferences" className="expandedpref noheight">
              <div className="checkbox checkbox-circle padtop">
                <input type="checkbox" name="receivetext" id="receivetext" className="styled" checked="checked" />
                <label htmlFor="receivetext">I would like to receive account related text messages</label>
              </div>
              <div className="checkbox checkbox-circle padtop">
                <input type="checkbox" name="receivemarketingtext" id="receivemarketingtext" className="styled" checked="checked" />
                <label htmlFor="receivemarketingtext">I would like to receive marketing and promotional text messaging</label>
              </div>
              <div className="checkbox checkbox-circle padtop">
                <input type="checkbox" name="receivemarketingcall" id="receivemarketingcall" className="styled"  />
                <label htmlFor="receivemarketingcall">I would like to receive marketing and promotional telephone calls</label>
              </div>
              <div className="checkbox checkbox-circle padtop">
                <input type="checkbox" name="subscribenews" id="subscribenews" className="styled" checked="checked" />
                <label htmlFor="subscribenews" className="padbottom">I would like to receive marketing and promotional e-mails</label>
              </div>
            </div>
          </div>

          <div className="changedrop">
            <h4 className="preferences" onClick={this.toggleReferences}>
              <svg className="actioncaret" width="20px" viewBox="0 0 20 20">
                <g strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-39.000000, -368.000000) translate(49.000000, 378.000000) scale(1, -1) translate(-49.000000, -378.000000) translate(40.000000, 369.000000)" stroke="#6E7677">
                  <circle className="Oval-3" strokeWidth="0.5" cx="9" cy="9" r="9"></circle>
                  <polyline className="downarrow" strokeWidth="1.0546875" strokeLinecap="round" points="6.19272374 10.2351675 8.90261101 7.47070736 11.6124983 10.2351675"></polyline>
                </g>
              </svg>
              <span>References</span>
            </h4>
            <div id="references" className="expandedpref noheight">
              <p className="text-center padtop">Your references must be over the age of 18 and not living in the same household as you.</p>
              <hr />
              <div className="detailsbox">
                <div id="ref1box">
                  <h5>Name</h5>
                  <p>{this.props.ref1fn} {this.props.ref1ln}</p>
                  <h5 className="padtop">Phone</h5>
                  <p>{this.props.ref1phn}</p>
                  <h5 className="padtop">Relationship</h5>
                  <p>{this.props.ref1rel}</p>
                  <svg className="editpen" onClick={this.editRef1Info} width="11px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                    <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
                  </svg>
                </div>
                <div id="ref1field" className="form-group hidden">
                  <label htmlFor="phn">
                    <div className="errortip hidden" id="phntip">
                        Please provide a valid phone number.
                    </div>
                    <h5>Name</h5>
                    <input type="text" name="fn1" id="fn1" className="form-control" placeholder="First Name" value={this.props.ref1fn} onChange={this.handleFn1Change} onBlur={this.handleFn1Blur} onKeyUp={this.handleFn1KeyUp}/>
                    <input type="text" name="ln1" id="ln1" className="form-control" placeholder="Last Name" value={this.props.ref1ln} onChange={this.handleLn1Change} onBlur={this.handleLn1Blur} onKeyUp={this.handleLn1KeyUp}/>
                    <h5 className="padtop">Phone</h5>
                    <input type="text" name="phn1" id="phn1" className="form-control" placeholder="eg: 512-123-4567" value={this.props.ref1phn} onChange={this.handlePhone1Change} onBlur={this.handlePhone1Blur} onKeyUp={this.handlePhone1KeyUp} maxLength="12"/>
                    <h5 className="padtop">Relationship</h5>
                    <input type="text" name="rel1" id="rel1" className="form-control" placeholder="eg: Father" value={this.props.ref1rel} onChange={this.handleRel1Change} onBlur={this.handleRel1Blur} onKeyUp={this.handleRel1KeyUp}/>
                  </label>
                </div>
              </div>
              <hr />
              <div className="detailsbox">
                <div id="ref2box">
                  <h5>Name</h5>
                  <p>{this.props.ref2fn} {this.props.ref2ln}</p>
                  <h5 className="padtop">Phone</h5>
                  <p>{this.props.ref2phn}</p>
                  <h5 className="padtop">Relationship</h5>
                  <p>{this.props.ref2rel}</p>
                  <svg className="editpen" onClick={this.editRef2Info} width="11px" viewBox="0 0 11 13" stroke="none" strokeWidth="1" transform="translate(-278.000000, -151.000000) translate(278.000000, 151.000000)" fill="#1565C0" fillRule="nonzero">
                    <path d="M10.009602,13 L10.009602,11.7404077 L0,11.7404077 L0,13 L10.009602,13 Z M2.85171692,10.009602 L0,10.009602 L0,7.15788505 L7.15775909,0 L10.009602,2.85171692 L2.85171692,10.009602 Z"></path>
                  </svg>
                </div>
                <div id="ref1field" className="form-group hidden">
                  <label htmlFor="phn">
                    <div className="errortip hidden" id="phntip">
                        Please provide a valid phone number.
                    </div>
                    <h5>Name</h5>
                    <input type="text" name="fn2" id="fn2" className="form-control" placeholder="First Name" value={this.props.ref2fn} onChange={this.handleFn2Change} onBlur={this.handleFn2Blur} onKeyUp={this.handleFn2KeyUp}/>
                    <input type="text" name="ln2" id="ln2" className="form-control" placeholder="Last Name" value={this.props.ref2ln} onChange={this.handleLn2Change} onBlur={this.handleLn2Blur} onKeyUp={this.handleLn2KeyUp}/>
                    <h5>Phone</h5>
                    <input type="text" name="phn2" id="phn2" className="form-control" placeholder="eg: 522-223-4567" value={this.props.ref2phn} onChange={this.handlePhone2Change} onBlur={this.handlePhone2Blur} onKeyUp={this.handlePhone2KeyUp} maxLength="12"/>
                    <h5>Relationship</h5>
                    <input type="text" name="rel2" id="rel2" className="form-control" placeholder="eg: Father" value={this.props.ref2rel} onChange={this.handleRel2Change} onBlur={this.handleRel2Blur} onKeyUp={this.handleRel2KeyUp}/>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <Link to="/dashboard/documents" className="changedrop">
            <h4 className="preferences">
              <span>Documents</span>
              <div className="circlebg actionicon">
                <svg className="reviewicon" width="21px" viewBox="0 0 21 24">
                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <path d="M20.002,14.3456 C20.3164,14.9315 20.4947,15.601 20.4947,16.3119 C20.4947,18.6126 18.6269,20.4804 16.3263,20.4804 C15.6465,20.4804 15.0044,20.3173 14.4372,20.0281 C15.4904,19.7164 16.6555,19.1094 17.6487,18.1968 C18.9107,17.0373 19.7046,15.5595 20.002,14.3456 Z" fill="#DBF0F4"></path>
                      <path d="M20.425,15.5492 C20.4708,15.7965 20.4947,16.0514 20.4947,16.3119 C20.4947,18.6126 18.6269,20.4804 16.3263,20.4804 C15.7465,20.4804 15.1942,20.3617 14.6923,20.1474 C15.8507,20.0218 17.2633,19.4831 18.4187,18.4776 C19.397,17.6263 20.0692,16.5462 20.425,15.5492 Z" fill="#C0DDE3"></path>
                      <path d="M18.4912,20.4092 L18.4912,22.0607 C18.4912,22.855 17.8464,23.4999 17.0519,23.5 L1.9393,23.5 C1.1449,23.5 0.5,22.8551 0.5,22.0607 L0.5,4.9857 C0.5,4.1913 1.1449,3.5464 1.9393,3.5464 L5.231,3.5464" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M13.8242,3.5464 L17.0519,3.5464 C17.8463,3.5464 18.4912,4.1913 18.4912,4.9857 L18.4912,12.1325" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M7.7987,1.8066 C8.0084,1.0534 8.6999,0.5 9.5196,0.5 C10.3393,0.5 11.0308,1.0534 11.2405,1.8066 L12.9187,1.8066 C13.1294,1.8066 13.3004,1.9776 13.3004,2.1882 L13.3004,5.017 C13.3004,5.2277 13.1294,5.3987 12.9187,5.3987 L6.1366,5.3987 C5.9259,5.3987 5.7549,5.2277 5.7549,5.017 L5.7549,2.1882 C5.7549,1.9776 5.9259,1.8066 6.1366,1.8066 L7.7987,1.8066 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M9.5276,1.2784 C10.0245,1.2784 10.4278,1.6818 10.4278,2.1786 C10.4278,2.6754 10.0245,3.0788 9.5276,3.0788 C9.0308,3.0788 8.6275,2.6754 8.6275,2.1786 C8.6275,1.6818 9.0308,1.2784 9.5276,1.2784 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M13.7256,16.8213 C15.0179,17.9407 15.6777,18.9544 15.6777,18.9544 C15.6802,18.961 16.8687,16.0403 18.927,14.4073" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M16.3263,12.1435 C18.6269,12.1435 20.4947,14.0113 20.4947,16.3119 C20.4947,18.6126 18.6269,20.4804 16.3263,20.4804 C14.0257,20.4804 12.1579,18.6126 12.1579,16.3119 C12.1579,14.0113 14.0257,12.1435 16.3263,12.1435 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,7.8534 L14.6,7.8356" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,10.787 L14.6,10.7692" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,19.778 L10.3354,19.7637" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,16.8433 L9.8585,16.8301" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,13.7013 L10.3354,13.687" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                  </g>
                </svg>
              </div>
            </h4>
          </Link>

          <Link to="/dashboard/changepassword" className="changedrop">
            <h4 className="preferences">
              <span>Change Password</span>
              <div className="circlebg actionicon">
                <svg className="reviewicon" width="21px" viewBox="0 0 21 24">
                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <path d="M20.002,14.3456 C20.3164,14.9315 20.4947,15.601 20.4947,16.3119 C20.4947,18.6126 18.6269,20.4804 16.3263,20.4804 C15.6465,20.4804 15.0044,20.3173 14.4372,20.0281 C15.4904,19.7164 16.6555,19.1094 17.6487,18.1968 C18.9107,17.0373 19.7046,15.5595 20.002,14.3456 Z" fill="#DBF0F4"></path>
                      <path d="M20.425,15.5492 C20.4708,15.7965 20.4947,16.0514 20.4947,16.3119 C20.4947,18.6126 18.6269,20.4804 16.3263,20.4804 C15.7465,20.4804 15.1942,20.3617 14.6923,20.1474 C15.8507,20.0218 17.2633,19.4831 18.4187,18.4776 C19.397,17.6263 20.0692,16.5462 20.425,15.5492 Z" fill="#C0DDE3"></path>
                      <path d="M18.4912,20.4092 L18.4912,22.0607 C18.4912,22.855 17.8464,23.4999 17.0519,23.5 L1.9393,23.5 C1.1449,23.5 0.5,22.8551 0.5,22.0607 L0.5,4.9857 C0.5,4.1913 1.1449,3.5464 1.9393,3.5464 L5.231,3.5464" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M13.8242,3.5464 L17.0519,3.5464 C17.8463,3.5464 18.4912,4.1913 18.4912,4.9857 L18.4912,12.1325" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M7.7987,1.8066 C8.0084,1.0534 8.6999,0.5 9.5196,0.5 C10.3393,0.5 11.0308,1.0534 11.2405,1.8066 L12.9187,1.8066 C13.1294,1.8066 13.3004,1.9776 13.3004,2.1882 L13.3004,5.017 C13.3004,5.2277 13.1294,5.3987 12.9187,5.3987 L6.1366,5.3987 C5.9259,5.3987 5.7549,5.2277 5.7549,5.017 L5.7549,2.1882 C5.7549,1.9776 5.9259,1.8066 6.1366,1.8066 L7.7987,1.8066 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M9.5276,1.2784 C10.0245,1.2784 10.4278,1.6818 10.4278,2.1786 C10.4278,2.6754 10.0245,3.0788 9.5276,3.0788 C9.0308,3.0788 8.6275,2.6754 8.6275,2.1786 C8.6275,1.6818 9.0308,1.2784 9.5276,1.2784 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M13.7256,16.8213 C15.0179,17.9407 15.6777,18.9544 15.6777,18.9544 C15.6802,18.961 16.8687,16.0403 18.927,14.4073" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M16.3263,12.1435 C18.6269,12.1435 20.4947,14.0113 20.4947,16.3119 C20.4947,18.6126 18.6269,20.4804 16.3263,20.4804 C14.0257,20.4804 12.1579,18.6126 12.1579,16.3119 C12.1579,14.0113 14.0257,12.1435 16.3263,12.1435 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,7.8534 L14.6,7.8356" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,10.787 L14.6,10.7692" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,19.778 L10.3354,19.7637" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,16.8433 L9.8585,16.8301" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M4.3913,13.7013 L10.3354,13.687" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                  </g>
                </svg>
              </div>
            </h4>
          </Link>

          <hr />

          <div id="faq">
            <h4>Frequently Asked Questions</h4>

            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <p>How do I finalize my application?</p>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <p>
                  If this is your first time borrowing with MoneyKey, welcome!
                  We will need to speak with you to review important information about your loan product to complete your application.<br />
                  <br />
                  If you have borrowed with us before, welcome back!
                  We may not need to speak with you to process your application.
                  However, if your information has changed, or it has been a while since you last borrowed with us,
                  we will need to quickly chat with you to make sure your information is up to date.
                </p>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <p>How do I update my information?</p>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <p>
                  To update your information, such as your address or income, you will need to speak with a Customer Care agent. In some cases, to update your information we may need documentation. Acceptable forms of documentation include, a bank statement, a utility bill, or State issued ID.
                </p>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <p>Can I make a payment online?</p>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <p>
                  Unfortunately, at this time MoneKey does not support online payments.
                  To make a payment, please contact our Customer Care team at <a href="tel:18662551668">1-866-255-1668</a>.<br />
                  <br />
                  You can make a payment over the phone using a debit card or a prepaid Netspend&reg; card under your name.
                  Alternatively, if you would like to make an additional payment in addition to your scheduled payment,
                  please contact us at least 24 hours ahead of your due date to arrange an additional payment.
                </p>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <p>Will you call my references?</p>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <p>
                  If we need to get in touch with you about your account, but are unable to reach you, your references may be contacted. Your privacy is important to us.
                  We will never disclose the nature of your business with MoneyKey to your references or employers.
                </p>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>

        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    page: state.FormReducer.page,
    pagename: state.FormReducer.pagename,
    status: state.FormReducer.status,
    noticedismissed: state.FormReducer.noticedismissed,
    accountnumber: state.FormReducer.accountnumber,
    eml: state.FormReducer.eml,
    phn: state.FormReducer.phn,
    street: state.FormReducer.street,
    city: state.FormReducer.city,
    st: state.FormReducer.st,
    stt: state.FormReducer.stt,
    zip: state.FormReducer.zip,
    ref1fn: state.FormReducer.ref1fn,
    ref1ln: state.FormReducer.ref1ln,
    ref1phn: state.FormReducer.ref1phn,
    ref1rel: state.FormReducer.ref1rel,
    ref2fn: state.FormReducer.ref2fn,
    ref2ln: state.FormReducer.ref2ln,
    ref2phn: state.FormReducer.ref2phn,
    ref2rel: state.FormReducer.ref2rel,
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setPage: (page) => dispatch(setPage(page))
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/Profile.js